const DASHBOARD_CONSTANTS = Object.freeze({
    SMALL_PAGE_SIZE: 5,
    DEFAULT_PAGE_SIZE: 20,
    ALL_TASKS_PAGE_SIZE: 10000, // Fetch all tasks for client-side pagination
    ALL_TASKS_CLIENT_SIDE_PAGE_SIZE: 50, // Client-side pagination page size for All Tasks page
    OPEN_CALCULATION_REVIEW_FIELDS: {
        WORKBOOK_NAME: {
            ACCESSOR: 'workbookName',
            HEADER: 'CWB',
            DB_FIELD: 'workbookName'
        },
        CALCULATION_NUMBER: {
            ACCESSOR: 'calculationNumber',
            HEADER: 'CLI',
            DB_FIELD: 'entity_id'
        },
        ATP_CALCULATION_STATUS: {
            ACCESSOR: 'atpCalculationStatus',
            HEADER: 'ATP CLI status',
            DB_FIELD: 'atpCalculationStatus'
        },
        APTTUS_CALCULATION_STATUS: {
            ACCESSOR: 'apttusCalculationStatus',
            HEADER: 'Apttus CLI status',
            DB_FIELD: 'apttusCalculationStatus'
        },
        TASK_STATUS: {
            ACCESSOR: 'taskStatus',
            HEADER: 'Status',
            DB_FIELD: 'taskStatus'
        },
        DUE_DATE: {
            ACCESSOR: 'dueDate',
            HEADER: 'Due date',
            DB_FIELD: 'due_date'
        },
        OWNER: {
            ACCESSOR: 'owner',
            HEADER: 'Owner',
            DB_FIELD: 'owner'
        },
        COMMENTS: {
            ACCESSOR: 'hasComments',
            HEADER: 'Comment',
            DB_FIELD: ''
        },
    },
    OPEN_APPROVAL_FIELDS: {
        ENTITY_ID: {
            ACCESSOR: 'entityId',
            HEADER: 'Action item',
            DB_FIELD: 'entityId'
        },
        ENTITY_TYPE: {
            ACCESSOR: 'entityType',
            HEADER: 'Category',
            DB_FIELD: 'entityType'
        },
        TASK_STATUS: {
            ACCESSOR: 'taskStatus',
            HEADER: 'Status',
            DB_FIELD: 'status'
        },
        DUE_DATE: {
            ACCESSOR: 'due_date',
            HEADER: 'Due date',
            DB_FIELD: 'due_date'
        },
        REQUESTER: {
            ACCESSOR: 'requester',
            HEADER: 'Requester',
            DB_FIELD: 'requester'
        }
    },
    OPEN_REQUEST_FIELDS: {
        ENTITY_ID: {
            ACCESSOR: 'entityId',
            HEADER: 'Action item',
            DB_FIELD: 'entityId'
        },
        ENTITY_TYPE: {
            ACCESSOR: 'entityType',
            HEADER: 'Category',
            DB_FIELD: 'entityType'
        },
        TASK_STATUS: {
            ACCESSOR: 'taskStatus',
            HEADER: 'Status',
            DB_FIELD: 'status'
        },
        DUE_DATE: {
            ACCESSOR: 'dueDate',
            HEADER: 'Due date',
            DB_FIELD: 'due_date'
        },
        APPROVER: {
            ACCESSOR: 'approver',
            HEADER: 'Approver',
            DB_FIELD: 'recipient'
        }
    },
    ENTITY_TYPES: {
        CALCULATION: 'CALCULATION',
        CDT: 'CDT',
        MULTIDIMENSIONAL_ALLOCATION_SHEET: 'MULTIDIMENSIONAL_ALLOCATION_SHEET',
        MULTIDIMENSIONAL_ALLOCATION_WORKSHEET: 'MULTIDIMENSIONAL_ALLOCATION_WORKSHEET'
    },
    ENTITY_TYPE_TO_DISPLAY_MAP: {
        'CALCULATION': 'Calculation',
        'MULTIDIMENSIONAL_ALLOCATION_SHEET': 'MDA Sheet',
        'MULTIDIMENSIONAL_ALLOCATION_WORKSHEET': 'MDA Worksheet'
    },
    ACTION_TYPE_TO_DISPLAY_MAP: {
        'UPDATE_CDT': 'Update CDT',
        'BEGINNING_BALANCE': 'Review Beginning Balance',        
    },
    OPEN_TASK_FIELDS: {
        ACTION_ITEM: {
            ACCESSOR: 'entityName',
            HEADER: 'Action item',
            DB_FIELD: 'entityName'
        },
        ACTION_TYPE: {
            ACCESSOR: 'notificationType',
            HEADER: 'Action type',
            DB_FIELD: 'notificationType'
        },
        RELATED_CLI: {
            ACCESSOR: 'relatedCalculationNumber',
            HEADER: 'Related CLI',
            DB_FIELD: 'relatedCalculationNumber'
        },
        VALUE: {
            ACCESSOR: 'cdtValueName',
            HEADER: 'CDT Value',
            DB_FIELD: 'cdtValueName'
        },
        PERIOD: {
            ACCESSOR: 'periodId',
            HEADER: 'Period',
            DB_FIELD: 'periodId'
        },
        TASK_STATUS: {
            ACCESSOR: 'taskStatus',
            HEADER: 'Status',
            DB_FIELD: 'status'
        },
        DUE_DATE: {
            ACCESSOR: 'dueDate',
            HEADER: 'Due date',
            DB_FIELD: 'due_date'
        },
        WORKBOOK_NAME: {
            ACCESSOR: 'workbookName',
            HEADER: 'Workbook name',
            DB_FIELD: 'workbookName'
        },
        WORKBOOK_OWNER: {
            ACCESSOR: 'workbookOwner',
            HEADER: 'Workbook owner',
            DB_FIELD: 'workbookOwner'
        },
        CLI_ASSIGNEE: {
            ACCESSOR: 'cliAssignee',
            HEADER: 'CLI assignee',
            DB_FIELD: 'cliAssignee'
        }
    },
    ACTIVE_STATUS: "Active",
    INACTIVE_STATUS: "Inactive",
    COMPLETE_STATUS: "Complete",
});

export default DASHBOARD_CONSTANTS;